import type { ErrorComponentProps } from '@tanstack/react-router'

import { PinStatus } from '@/modules/graphql/codegen/graphql'
import { Forbidden } from '@/pages/Forbidden'

export class ForbiddenError extends Error {
  constructor(message = 'Forbidden') {
    super(message)
    this.name = 'ForbiddenError'
  }
}

export function requirePermission(
  permissions: string[],
  required: string,
): void {
  if (!permissions.includes(required)) {
    throw new ForbiddenError()
  }
}

export function requireAnyPermission(
  permissions: string[],
  required: string[],
): void {
  if (required.length === 0) return

  if (!required.some((p) => permissions.includes(p))) {
    throw new ForbiddenError()
  }
}

/**
 * Blocks a route when the GxP add-on is disabled for this environment
 * (`pinStatus === DISABLED`, driven by the BFF's `gxp_enforcement_enabled`
 * flag). `null` is treated as enabled — `__root` leaves `pinStatus` null under
 * `VITE_DEV_PERMISSIONS` dev overrides, and we must not hide GxP UI from devs.
 */
export function requireGxpEnabled(pinStatus: PinStatus | null): void {
  if (pinStatus === PinStatus.Disabled) {
    throw new ForbiddenError()
  }
}

export function forbiddenErrorComponent({ error }: ErrorComponentProps) {
  if (error instanceof ForbiddenError) {
    return <Forbidden />
  }
  throw error
}
